const styles = theme => ({
  cardButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: theme.spacing.unit,
  },
  cardButtons: {
    display: 'flex',
    flexDirection: 'row',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/map/ListItem/CardButtons/styles.js